import React from 'react'
import { Link, LinkBack } from 'libs/utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons'
import './Content.scss'


export function ContentHeader({
  back,
  title,
  buttons
}) {

  const backButton = !back ? null : (
    back === true ?
      <LinkBack className="back-button">
        <FontAwesomeIcon icon={faChevronLeft} />
      </LinkBack>
      :
      <Link className="back-button" to={back}>
        <FontAwesomeIcon icon={faChevronLeft} />
      </Link>
  )

  return (
    <div className="app-layout-content-header">
      <div className="content-header-title">
        {backButton}
        {title}
      </div>
      <div className="content-header-buttons">{buttons}</div>
    </div>
  )
}

ContentHeader.defaultProps = {
  back: false, // If true, will navigate back. If a string, will navigate to the string (URL path).
  title: 'No Title',
  buttons: null,
}

export function ContentMain({
  maxWidth,
  noWrapper,
  children
}) {

  return (
    <main className="app-layout-content">
      {noWrapper ?
        children
        :
        <div className="content-wrapper">
          {React.Children.map(children, (child, index) => React.isValidElement(child) && (
            <div key={index} className="content" style={{ maxWidth: !maxWidth ? "unset" : maxWidth === true ? "1200px" : maxWidth }}>
              {child}
            </div>
          ))}
        </div>
      }
    </main>
  )
}

ContentMain.defaultProps = {
  maxWidth: false, // Boolean or String as "1200px"
  noWrapper: false,
  children: null,
}

export default function Content({
  back,
  title,
  buttons,
  maxWidth,
  noWrapper,
  children,
}) {
  return (
    <>
      <ContentHeader
        back={back}
        title={title}
        buttons={buttons}
      />
      <ContentMain
        maxWidth={maxWidth}
        noWrapper={noWrapper}
        children={children}
      />
    </>
  )
}
